module.exports = __webpack_public_path__ + "img/rectangle_selected.488099cb.svg";